
<div [ngClass]="electionService.isMobile ? 'first-pref-table-phone' :'first-pref-table'">
    <div *ngIf="hasData">
        <table mat-table [dataSource]="dataSource" >
            <!-- Candidate header row (names + Total Votes with colspans) -->
            <ng-container *ngFor="let header of candidateHeaders; trackBy: trackByDistrictAndColumn" matColumnDef="{{header.column}}">
                <th mat-header-cell *matHeaderCellDef [attr.colspan]="header.colspan"
                    [ngClass]="{'header-cell-place': header.column === 'headerPlace', 'header-cell-right': header.column !== 'headerPlace'}">
                    <div *ngIf="header.colourCode !== null" class="header-with-color">
                        <span class="color-indicator" [ngStyle]="{'background-color': header.colourCode}"></span>
                        <span class="header-labels">
                            <span class="header-label-line">{{header.label}}</span>
                            <span class="header-label-abbr" *ngIf="header.labelTwo">{{header.labelTwo}}</span>
                        </span>
                    </div>
                    <div *ngIf="header.colourCode === null" class="header-total-label">{{header.label}}</div>
                </th>
            </ng-container>

            <ng-container *ngFor="let col of columns; trackBy: trackByDistrictAndColumn; let i = index;" matColumnDef="{{col.column}}" >
                <th mat-header-cell *matHeaderCellDef
                    [ngClass]="{
                      'col-polling-place': col.column === '0',
                      'col-votes': col.column === '1' || col.column === '3' || col.column === '5',
                      'col-percent': col.column === '2' || col.column === '4' || col.column === '6'
                    }"
                    class="column-header-cell">
                    <div class="column-header-content">
                        <div *ngIf="col.isRightJustify === false" class="column-header-line">{{col.label}}</div>
                        <div class="value-justify-right column-header-line" *ngIf="col.isRightJustify === true">{{col.label}}</div>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element"
                    [ngClass]="{
                      'col-polling-place': col.column === '0',
                      'col-votes': col.column === '1' || col.column === '3' || col.column === '5',
                      'col-percent': col.column === '2' || col.column === '4' || col.column === '6'
                    }">
                    <div *ngIf="col.isColour" [style.width.px]="col.minWidth">
                        <mat-icon class="party-colour" [ngStyle]="{'color': element.colourCode}">
                            rectangle
                        </mat-icon>
                    </div>
                    <div [style.min-width.px]="col.minWidth" class="value-justify-right"  *ngIf="col.isRightJustify&&col.isPercent===false">
                        <div [ngClass]="isBold(element[0]) ? 'text-bold' : 'text-plain'">
                            {{element[col.column]|number}}
                        </div>
                    </div>
                    <div [style.min-width.px]="col.minWidth" class="value-justify-right"  *ngIf="col.isPercent">
                        <div *ngIf="col.isColourBar">
        
                        </div>
                        <div [ngClass]="isBold(element[0]) ? 'text-bold' : 'text-plain'">
                            {{(element[col.column]===null?'n/a':element[col.column])|percent :'1.1-1'}}
                        </div>
                    </div>
                    <div [style.min-width.px]="col.minWidth" *ngIf="col.isRightJustify===false&&col.isColour===false">
                        <div [ngClass]="isBold(element[0]) ? 'text-bold' : 'text-plain'">
                            {{element[col.column]}}
                        </div>
                    </div>
                </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="candidateHeaderColumns" class="candidate-header-row"></tr>
            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="column-header-row"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                [ngClass]="{'section-separator': isSectionSeparator(row[0]), 'section-first-row': isSectionFirstRow(row[0])}"></tr>
        </table>
    </div>
</div>
<div *ngIf="hasData===false" style="text-align: center;">Data not available</div> 